// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Dynamic report file mapping upload/download'" ></sub-header>

  <dynamic-report-mapping-manual max-height="400px"></dynamic-report-mapping-manual>

  <form name="\$ctrl.form">
    <h2 class="section-header">Download mapping</h2>
    <report-filters config="\$ctrl.filterConfig" params="\$ctrl.filters"></report-filters>

    <h2 class="section-header">Upload mapping {{\$ctrl.filters.fileId ? "for " + \$ctrl.filters.fileId : ""}}</h2>
    <file-upload ng-model="\$ctrl.file"
                 max-files="1"
                 ng-change="\$ctrl.uploadFile()"
                 skip-upload="true"
                 validate="{pattern: '.xls,*.xlsx', size: { max: '3MB'}}"
                 enable-webcam="false"
                 show-remarks="false">
    </file-upload>
  </form>

  <div class="summary-actions">
    <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/mapping/upload/dynamic-report-mapping-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;